import React, { useState } from 'react'
import Portal from '../Portal/Portal'
import Overlay from '../Overlay/Overlay'
import CleverAlphaButton from '../CleverAlphaButton/CleverAlphaButton'
import DoubleSlider from '../DoubleSlider/DoubleSlider'
import InputField from '../InputField/InputField'
import { addYearsToDate, formatToDash, getMaturityYears } from '../../helper/helpers'
import ConfirmationModal from './confirmation_modal'
import { setUserEndDate } from '../../dashboard/user/actions'
import AdjustTimeHistory from './adjust_time_history'
import { useDispatch } from 'react-redux'
import { updateMaturityDate } from './reducer'



const AdjustTimeModal = ({ token, account, handleClose, username, accountIndex, wlfId, itemIndex }) => {
    const { end_date: endDate, current_date: currentDate } = account;
    const min = 0;
    const max = 100;
    const maturityYears = getMaturityYears(endDate, currentDate);

    const [timeValue, setTimeValue] = useState(maturityYears);
    const [timeLabelValue, setTimeLabelValue] = useState(maturityYears);
    const [maturityHistory, setMaturityHistory] = useState([]);
    const dispatch = useDispatch();

    const handleSliderChange = (value) => {
        setTimeLabelValue(value);
        setTimeValue(value);
    }
    const handleChange = (e) => {
        const value = e.target.value;
        const isInBetweenZeroAndOneHundred = /^$|^(\d{1,2}|100)$/;
        if(!isInBetweenZeroAndOneHundred.test(value)) {
            return;
        }

        const labelValue = value ? value : 0;
        setTimeLabelValue(value);
        setTimeValue(labelValue);
    }

    const handleSubmit = async () => {
        try {
            const newEndDate = addYearsToDate(currentDate, timeValue);
            const formatEndDate = formatToDash(newEndDate);
            const response = await setUserEndDate(token, username, accountIndex, newEndDate, timeValue);
            if(response.status !== "OK") {
                throw new Error("Something went wrong");
            }

            setMaturityHistory(response.payload);
            dispatch(updateMaturityDate(formatEndDate, wlfId, itemIndex));
        } catch (error) {
            console.log(error);
        } 

        return handleClose;
    }

    const handleSetHistory = (history) => {
        setMaturityHistory(history);
    }

    const title = 'Time Horizon';
    const content = 'Increasing the time horizon of your portfolio will increase your exposure to volatility which may increase the long run expected return of your portfolio; however, it also may increase the possibility for draw downs of your portfolio value.';

    return (
        <Portal>
            <Overlay>
                <div style={{ display: "flex", justifyContent: "center", gap: "8px", width: "80%"}}>
                    <div style={{ display: "flex", flexDirection: "column", position: "relative", backgroundColor: "white", padding: "24px 48px", border: "1px solid black", width: "60%"}}>
                        <div style={{ fontWeight: "bold", fontSize: "16px" }} >Portfolio Adjustment - Time</div>
                        
                        <div style={{ marginBottom: '24px' }}>
                            <DoubleSlider min={min} max={max} value={timeValue} currentValue={maturityYears} labelEndText={'Years'} horizontalLabel={'Years to Maturity'} onChange={handleSliderChange}/>
                        </div>

                        <div style={{ marginBottom: '24px' }}>
                            <InputField name="time" label="Time" value={timeLabelValue} onChange={handleChange}/>
                        </div>

                        <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: 'auto' }}>
                            <CleverAlphaButton onClick={handleClose}>Cancel</CleverAlphaButton>
                            <ConfirmationModal title={title} content={content} handleSubmit={handleSubmit}>Ok</ConfirmationModal>
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", position: "relative", backgroundColor: "white", padding: "24px", border: "1px solid black"}}>
                        <div style={{ fontWeight: "bold", fontSize: "16px" }}>Portfolio Adjustment Time History</div>
                        <AdjustTimeHistory history={maturityHistory} setHistory={handleSetHistory} token={token} username={username} accountIndex={accountIndex}/>
                    </div>
                </div>
            </Overlay>
        </Portal>
    )
}

export default AdjustTimeModal